import axios, { AxiosResponse } from "axios";
import { IGlobalSearchApi } from "./IGlobalSearchApi";
import { GlobalSearchFilterInput } from "../models/GlobalSearchFilterInput";
import { GlobalSearchFilter } from "./models/GlobalSearchFilter";

class GlobalSearchApi implements IGlobalSearchApi {
    private baseUrl: string;

    constructor() {
        this.baseUrl = '/Umbraco/Api/GlobalSearchApi';
    }

    public async search(
        filters: GlobalSearchFilterInput | null, 
        page: number | null, 
        documentType: string[] | null, 
        categories: string[] | null, 
        language: string
    ): Promise<AxiosResponse<any, any>> {
        const url = `${this.baseUrl}/search`;

        if (documentType && filters?.documentTypes?.length === 0) {
            filters.documentTypes.push(...documentType);
        }
        if (categories && filters?.categories?.length === 0) {
            filters.categories.push(...categories);
        }

        const params: GlobalSearchFilter = {
            term: filters?.term,
            documentTypes: filters?.documentTypes,
            dateFrom: filters?.dateFrom,
            dateTo: filters?.dateTo,
            orderBy: filters?.orderBy,
            orderByAsc: filters?.orderByAsc,
            onlyRead: filters?.onlyRead,
            industries: filters?.industries,
            categories: filters?.categories,
            networks: filters?.networks,
            ids: filters?.ids,
            ancestorId: filters?.ancestorId,
            page: page,
            language: language,
            caseName: filters?.courts,
            editedDateFrom: filters?.editedDateFrom,
            editedDateTo: filters?.editedDateTo,
            legislationStatus: filters?.legislationStatus,
            count: 10
        };

        const paramsString = this.serializeParams(params);
        const response = await axios.get(url + paramsString);

        return response;
    }

    private serializeParams(params: Record<string, any>): string {
        const queryParams: string[] = [];
    
        Object.keys(params).forEach(key => {
            const value = params[key];
            if (Array.isArray(value)) {
                value.forEach(item => {
                    queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
                });
            } else if (value !== null && value !== undefined) {
                queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
            }
        });
    
        return queryParams.length ? '?' + queryParams.join('&') : '';
    }

    public async getFilters(taxonomyId: number): Promise<AxiosResponse<any, any>> {
        const url = `${this.baseUrl}/getFilters`;
        const params = { taxonomyId }; 
        const paramsString = this.serializeParams(params);
        
        const response = await axios.get(url + paramsString);
    
        return response;
    }

    public async suggest(term: string): Promise<string[]> {
        const url = `${this.baseUrl}/suggest`;
        const params = { term, count: 10 }; 
        const paramsString = this.serializeParams(params as GlobalSearchFilter);

        const response = await axios.get(url + paramsString);

        return response.data;
    }
}

const globalSearchApi = new GlobalSearchApi();

export default globalSearchApi;